// Horizontal product rails: arrow buttons scroll by most of a screen and grey out at either end.
export function mountRails(root = document) {
  root.querySelectorAll('[data-rail]').forEach(b => {
    const rail = document.getElementById(b.dataset.rail); if (!rail || b.dataset.bound) return;
    b.dataset.bound = '1';
    b.addEventListener('click', () => rail.scrollBy({ left: +b.dataset.dir * rail.clientWidth * 0.75, behavior: 'smooth' }));
  });
  root.querySelectorAll('.rail').forEach(rail => {
    if (rail.dataset.bound) return; rail.dataset.bound = '1';
    if (!rail.hasAttribute('tabindex')) rail.tabIndex = 0;            // keyboard users can scroll it
    if (!rail.hasAttribute('role')) { rail.setAttribute('role', 'region'); rail.setAttribute('aria-label', rail.closest('section')?.querySelector('h2')?.textContent || 'Products'); }
    const arrows = root.querySelectorAll(`[data-rail="${rail.id}"]`);
    const sync = () => arrows.forEach(a => {
      const end = +a.dataset.dir > 0 ? rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2 : rail.scrollLeft <= 2;
      a.disabled = end;
    });
    rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    new ResizeObserver(sync).observe(rail);
    sync();
  });
}
